
import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import notifications from "@/lib/notifications";
import { BulkInventoryItemListFilters } from "@/models/api/barcodeSystem/inventory/bulkInventoryItems";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";
import Papa from "papaparse";

const inventoryModuleState = getModule(InventoryModule);
const barcodeSystemModuleState = getModule(BarcodeSystemModule);

@Component
export default class InventoryItemFilters extends Vue {
  localFilters: BulkInventoryItemListFilters = null;

  get filters() {
    return inventoryModuleState.bulkFilters;
  }

  created() {
    this.localFilters = JSON.parse(JSON.stringify(this.filters));
  }

  async submit() {
    inventoryModuleState.setBulkFilters(JSON.parse(JSON.stringify(this.localFilters)));
    inventoryModuleState.setLoading(true);
    try {
      await inventoryModuleState.getBulkInventoryItems({
        pageNumber: 1,
        pageSize: inventoryModuleState.bulkPageData.pageSize
      });
    } catch (ex) {
      notifications.error("Loading Bulk Inventory Items", "Failed to load bulk inventory items", ex);
    }

    inventoryModuleState.setLoading(false);
  }
  
  async exportBulkInventoryItems() {
    inventoryModuleState.setLoading(true);
    try {    
      var csvData = [];
      var i = [];
      inventoryModuleState.bulkFields.forEach(function (field) {
        if(field.label !== "" && field.hidden === false) {
          i.push(field.label);
        }
      });
      csvData.push(i);
      if(inventoryModuleState.bulkPageData.totalItems > inventoryModuleState.bulkData.length){
        if(inventoryModuleState.bulkPageData.totalItems < 5000) {
          await inventoryModuleState.getBulkInventoryItemsExport({
            pageNumber: 1,
            pageSize: inventoryModuleState.bulkPageData.totalItems
          });
        } else {
          await inventoryModuleState.getBulkInventoryItemsExport({
            pageNumber: 1,
            pageSize: 5000
          });
        }
      }
      inventoryModuleState.bulkData.forEach(function (item) {
        var i = [];
        inventoryModuleState.bulkFields.forEach(function (field) {
          if(field.label !== "" && field.hidden === false) {
            if(field.label === "Company") {
              i.push(item.company.companyName);
            } else if(field.label === "Qty") {
              i.push(field.formatter(item[field.key], item[field.formatterParameterKey]));
            } else  {
              i.push(item[field.key]);
            }
          }
        });
        csvData.push(i);
      });  
      let blob = new Blob([Papa.unparse(csvData)], {
        type: "text/csv;charset=utf-8;"
      });

      let link = document.createElement("a");

      let url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "BulkInventoryItems.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (ex) {
      console.log(ex);
      notifications.error("Downloading Bulk Inventory Items", "Failed to export bulk inventory items", ex);
    }

    inventoryModuleState.setLoading(false);
  }

  get currentFacilityCode(): string {
    return barcodeSystemModuleState.currentFacilityCode;
  }

  get loading(): boolean {
    return inventoryModuleState.loading;
  }

  getBooleanOptions() {
    return [
      { label: "", value: null },
      { label: "Yes", value: true },
      { label: "No", value: false }
    ];
  }
}
